import {
  LoadingSpinnerProps,
  IconProps,
  TextProps,
  ButtonProps,
} from 'spindl-shared-components';
import { TableProps } from '../../organisms/Table';

type TableBlockInternalProps = {
  table?: TableProps;
  icon?: IconProps;
  title?: TextProps;
  instructions?: TextProps;
  loadingSpinner?: LoadingSpinnerProps; // MANUAL OVERRIDE
  clearFiltersButton?: ButtonProps; // MANUAL OVERRIDE
};

type TableBlockPropsValues = {
  Default: TableBlockInternalProps;
  NoResults: TableBlockInternalProps;
};

const propValues: TableBlockPropsValues = {
  Default: {
    table: {},
    // MANUAL OVERRIDE
    loadingSpinner: {
      size: 'Large',
      styleType: 'Primary',
    },
  },
  // MANUAL OVERRIDE FOR WHITE MODE
  NoResults: {
    table: {},
    icon: {
      asset: 'Search',
      colour: 'IconSubdued',
    },
    title: {
      align: 'Center',
      styleType: 'SemiBold',
      colour: 'Dark',
      type: 'Heading2',
    },
    instructions: {
      align: 'Center',
      styleType: 'Regular',
      colour: 'Subdued',
      type: 'Body1',
    },
    clearFiltersButton: { // MANUAL OVERRIDE
      type: 'TextNoBG',
      size: 'S',
      styleType: 'Primary',
      state: 'Default',
    },
  },
};

const getProps = (type: string): TableBlockInternalProps => {
  const values: TableBlockInternalProps = propValues[type];
  if (!values) {
    console.error(`${type} props not found`);
    return {};
  }
  return values;
};

export default getProps;
